import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BulkUpdateDatasetsRequest } from './models/bulk-update-datasets-request.model';
import { DataCategory } from './models/data-category.model';

@Injectable({
    providedIn: 'root',
})
export class DataCategoriesService {
    public constructor(private readonly httpClient: HttpClient) {}

    public listDataCategories(): Observable<DataCategory[]> {
        return this.httpClient
            .get<DataCategory[]>('data-categories')
            .pipe(map((categories) => categories.filter((category) => category.id >= 0)));
    }

    public bulkUpdateDatasets(
        businessDomainId: string,
        dataCategoryId: number,
        request: BulkUpdateDatasetsRequest,
    ): Observable<void> {
        return this.httpClient.post<void>(
            `business-domains/${businessDomainId}/data-categories/${dataCategoryId}/bulk_update`,
            request,
        );
    }
}
